import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { StartIcon } from "./StartIcon";
import { LevelButton } from "./LevelButton";
import { StartSimulationButton } from "./StartSimulationButton";

import Level_one_icon from "./img/Level_one.svg";
import Level_two_icon from "./img/Level_two.svg";
import Level_three_icon from "./img/Level_three.svg";

import "./style.scss";

/**
 * Contents displayed inside LevelSelection Modal Window of Experimental-Design.
 */
export function LevelSelector(props) {
  const [simulationLevels, updateSimulationLevels] = useState([]);

  useEffect(() => {
    updateSimulationLevels(
      makeSimulationlevelList(props.defaultSelected)(props.simulationLevels)
    );

    // console.log('setting simulation level ');
    // props.setLevel({id:1, value:'levelOne'});
    // props.setLevel({id:2, value:'levelTwo'});
    // props.setLevel({id:3,value:'levelThree'});


  }, []);

  function updateSelectedLevel(id) {
    updateSimulationLevels((levelList) =>
      makeSimulationlevelList(id)(levelList)
    );
  }

  const getLevelIcon = (level) => {

    let icon = Level_one_icon

    switch(level.id){
      case 1:
        icon = Level_one_icon;
        break;
      case 2:
        icon = Level_two_icon;
        break;
      case 3:
        icon = Level_three_icon;
        break;
    }

    return icon
  }

  const renderLevelButtons = () =>
    simulationLevels.map((level) => (
      <LevelButton
        key={level.id}
        tabIndex={0}
        onClick={updateSelectedLevel}
        className="level-selection__levelbutton"
        levelID={level.id}
        selected={level.selected}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ display: "flex", background: "#003e6b", borderRight: "1px solid white" }}>
            <img style={{ width: "140px", height: "auto"}} src={getLevelIcon(level)} alt={level.label}/>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "16px",
            }}
          >
            <h3 style={{ margin: 0 }}>{level.label}</h3>
            <p style={{ margin: "8px 0 0" }}>{level.description}</p>
          </div>
        </div>
      </LevelButton>
    ));

  const setLevel = (event) => {
    event.preventDefault();
    props.setLevel(getSelectedLevel(simulationLevels));
  };

  const getCurrentLevel = () => {
    let dict = ["one", "two", "three"];
    let currentLevelIndex = -1;

    simulationLevels.forEach((level, index) => {
      if (level.selected) {
        currentLevelIndex = index;
      }
    });

    return dict[currentLevelIndex];
  };

  return (
    <div className="level-selection">
      <div className="level-selection__title">
        <h2>Select a level</h2>
      </div>
      {renderLevelButtons()}
      <div className="level-selection__submit">
        <StartSimulationButton onClick={setLevel}>
          <StartIcon />
          {/* {"Start level " + getCurrentLevel()} */}
          {"Start level three"}
        </StartSimulationButton>
      </div>
    </div>
  );
}

LevelSelector.propTypes = {
  /**
   * List of levels for the simultion
   */
  simulationLevels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  /**
   * Button to be selectedBy default
   */
  defaultSelected: PropTypes.number.isRequired,
  /**
   * Callback function to be executed when you click the Start Simulation Button
   */
  setLevel: PropTypes.func.isRequired,
};

LevelSelector.defaultProps = {
  simulationLevels: [],
  defaultSelected: 0,
};

function makeSimulationlevelList(selectedID) {
  return function (levelList) {
    return levelList.map((level) => ({
      ...level,
      selected: selectedID === level.id ? true : false,
    }));
  };
}

function getSelectedLevel(levelList) {
  return levelList.find((level) => level.selected);
}
